// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Base styles */
/* body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: #f5f5f5;
  color: #333;
}

* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
} */

button {
  font-family: inherit;
}

/* Custom scrollbar */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb {
  background: #65ccb7;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: #55bb9f;
}

/* Container and Layout */
.super-admin-container {
  max-width: 67%;
  margin: 0 auto;
  padding: 10px;
}

.super-admin-header {
  margin-bottom: 30px;
  width: 120.5%;
  background: white;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
}

.super-admin-header h1 {
  color: #65ccb7;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 2.2em;
}

.header-icon {
  font-size: 1.8em;
}

.super-admin-nav {
  display: flex;
  gap: 12px;
  margin-bottom: 20px;
}

.super-admin-tab {
  padding: 12px 24px;
  border: none;
  background: #f5f5f5;
  cursor: pointer;
  border-radius: 8px;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 1.1em;
  font-weight: 500;
  color: #666;
}

.tab-icon {
  font-size: 1.1em;
}

.super-admin-tab:hover {
  background: #e5e5e5;
  transform: translateY(-1px);
}

.super-admin-tab.active {
  background: #65ccb7;
  color: white;
  box-shadow: 0 4px 12px rgba(101, 204, 183, 0.2);
}

.super-admin-main {
  width: 120%;
  height: 65.5vh;
  background: white;
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  padding: 24px;
}`, "",{"version":3,"sources":["webpack://./src/SuperAdmin/SuperAdmin.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;;;;;;;;;;;;;;;GAeG;;AAEH;EACE,oBAAoB;AACtB;;AAEA,qBAAqB;AACrB;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,yBAAyB;AACzB;EACE,cAAc;EACd,cAAc;EACd,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,+CAA+C;AACjD;;AAEA;EACE,WAAW;EACX,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,0CAA0C;EAC1C,aAAa;AACf","sourcesContent":["/* Base styles */\n/* body {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background-color: #f5f5f5;\n  color: #333;\n}\n\n* {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n} */\n\nbutton {\n  font-family: inherit;\n}\n\n/* Custom scrollbar */\n::-webkit-scrollbar {\n  width: 8px;\n  height: 8px;\n}\n\n::-webkit-scrollbar-track {\n  background: #f1f1f1;\n  border-radius: 4px;\n}\n\n::-webkit-scrollbar-thumb {\n  background: #65ccb7;\n  border-radius: 4px;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: #55bb9f;\n}\n\n/* Container and Layout */\n.super-admin-container {\n  max-width: 67%;\n  margin: 0 auto;\n  padding: 10px;\n}\n\n.super-admin-header {\n  margin-bottom: 30px;\n  width: 120.5%;\n  background: white;\n  padding: 20px;\n  border-radius: 10px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);\n}\n\n.super-admin-header h1 {\n  color: #65ccb7;\n  margin-bottom: 20px;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 2.2em;\n}\n\n.header-icon {\n  font-size: 1.8em;\n}\n\n.super-admin-nav {\n  display: flex;\n  gap: 12px;\n  margin-bottom: 20px;\n}\n\n.super-admin-tab {\n  padding: 12px 24px;\n  border: none;\n  background: #f5f5f5;\n  cursor: pointer;\n  border-radius: 8px;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 1.1em;\n  font-weight: 500;\n  color: #666;\n}\n\n.tab-icon {\n  font-size: 1.1em;\n}\n\n.super-admin-tab:hover {\n  background: #e5e5e5;\n  transform: translateY(-1px);\n}\n\n.super-admin-tab.active {\n  background: #65ccb7;\n  color: white;\n  box-shadow: 0 4px 12px rgba(101, 204, 183, 0.2);\n}\n\n.super-admin-main {\n  width: 120%;\n  height: 65.5vh;\n  background: white;\n  border-radius: 10px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);\n  padding: 24px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
